import { getThemeVariable } from '~/utils/getThemeVariable';

export enum SliderFilterThemeVars {
    '--slider-filter-track-color' = '--slider-filter-track-color',
    '--slider-filter-track-border' = '--slider-filter-track-border',
    '--slider-filter-rail-color' = '--slider-filter-rail-color',
    '--slider-filter-thumb-color' = '--slider-filter-thumb-color',
    '--slider-filter-thumb-width' = '--slider-filter-thumb-width',
    '--slider-filter-thumb-height' = '--slider-filter-thumb-height',
    '--slider-filter-thumb-border-radius' = '--slider-filter-thumb-border-radius',
    '--slider-filter-thumb-box-shadow' = '--slider-filter-thumb-box-shadow',
    '--slider-filter-thumb-hover-box-shadow' = '--slider-filter-thumb-hover-box-shadow',
    '--slider-filter-thumb-focus-visible-box-shadow' = '--slider-filter-thumb-focus-visible-box-shadow',
    '--slider-filter-disabled-color' = '--slider-filter-disabled-color',
}

export const getSliderStyles = () => {
    return {
        '& .MuiSlider-thumb': {
            width: getThemeVariable(SliderFilterThemeVars['--slider-filter-thumb-width']),
            height: getThemeVariable(SliderFilterThemeVars['--slider-filter-thumb-height']),
            borderRadius: getThemeVariable(SliderFilterThemeVars['--slider-filter-thumb-border-radius']),
            bgcolor: getThemeVariable(SliderFilterThemeVars['--slider-filter-thumb-color']),

            cursor: 'pointer',
            '::after': {
                pointerEvents: 'auto',
            },
            boxShadow: getThemeVariable(SliderFilterThemeVars['--slider-filter-thumb-box-shadow']),
        },
        '& .MuiSlider-thumb:hover': {
            boxShadow: getThemeVariable(SliderFilterThemeVars['--slider-filter-thumb-hover-box-shadow']),
        },
        '& .MuiSlider-thumb.Mui-focusVisible': {
            boxShadow: getThemeVariable(SliderFilterThemeVars['--slider-filter-thumb-hover-box-shadow']),
        },
        '& .MuiSlider-track': {
            bgcolor: getThemeVariable(SliderFilterThemeVars['--slider-filter-track-color']),
            border: getThemeVariable(SliderFilterThemeVars['--slider-filter-track-border']),
        },
        '& .MuiSlider-rail': {
            bgcolor: getThemeVariable(SliderFilterThemeVars['--slider-filter-rail-color']),
        },
        '& .MuiSlider-thumb.Mui-disabled': {
            bgcolor: getThemeVariable(SliderFilterThemeVars['--slider-filter-disabled-color']),
        },
        '&.Mui-disabled .MuiSlider-track': {
            bgcolor: getThemeVariable(SliderFilterThemeVars['--slider-filter-disabled-color']),
            border: getThemeVariable(SliderFilterThemeVars['--slider-filter-disabled-color']),
        },
        '& .MuiSlider-rail.Mui-disabled': {
            bgcolor: getThemeVariable(SliderFilterThemeVars['--slider-filter-disabled-color']),
        },
    };
};
